module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration005.dd28cec1.webp";